import React, { useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import MobilePopUp from '../../components/MobilePopUp/MobilePopUp';
import { toaster } from '../../utils/utils'
import apiConstants from '../../constans/apiConstants';
import DataTable from '../../components/Table';
import YesNoRadioButton from '../../components/YesNoRadioButton';
import { getProductList } from '../../store/actions/productConfigActions';

const normalizeProductSearchText = (value) => String(value ?? '').trim().toLowerCase();

const getProductSearchText = (product) => [
    product?.productName,
    product?.productCode,
    product?.productType,
]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

const productMatchesSearch = (product, query) => {
    const normalizedQuery = normalizeProductSearchText(query);
    if (!normalizedQuery) {
        return true;
    }

    const searchableText = getProductSearchText(product);
    const terms = normalizedQuery.split(/\s+/).filter(Boolean);

    return terms.every((term) => searchableText.includes(term));
};

const InstaVerifyList = () => {
    const isDev = window.envType === "DEV";
    const [proposalNumber, setProposal] = useState({
        partnerName: '',
        subChannel: '',
        channel: '',
        sources: ''
    });
    const [showEditModal, setshowEditModal] = useState(false);
    const [showEasePointingModal, setShowEasePointingModal] = useState(false);
    const [easePointingRow, setEasePointingRow] = useState(null);
    const [selectedProductCodes, setSelectedProductCodes] = useState([]);
    const [easePointingProductSearch, setEasePointingProductSearch] = useState('');
    const [data, setData] = useState()
    const [apiPaymantOption, setApiPayment] = useState()
    const productList = useSelector((state) => state?.productTypeData?.productList || []);
    const filteredEasePointingProducts = useMemo(
        () => productList.filter((product) => productMatchesSearch(product, easePointingProductSearch)),
        [productList, easePointingProductSearch]
    );
    // const [options, setOptions] = useState({
    //     initialPaymentOptions: [
    //         { value: "CASH|Cash", active: true },
    //         { value: "CHEQUE|Cheque", active: false },
    //         { value: "DEMAND_DRAFT|Demand draft", active: false },
    //         { value: "NEFT|NEFT", active: false },
    //         { value: "ONLINE_LINK|Online link", active: false },
    //         { value: "ONLINE_BILL_DESK|Online Payment", active: false },
    //         { value: "PAYMENT_AT_BANK_CHEQUE|Pay at bank cheque", active: false },
    //         { value: "PAYMENT_AT_BANK_CASH|Pay at bank cash", active: false },
    //         { value: "FUND_TRANSFER|Fund Transfer", active: false }],
    //     initialPaymentAtBankOptions: [
    //         { value: "ALLAHABAD_BANK|Allahabad Bank", active: false },
    //         { value: "YES_BANK|Yes Bank", active: false },
    //         { value: "AXIS_BANK|Axis Bank", active: false },
    //         { value: "KBL_BANK|Karnataka Bank", active: false },
    //         { value: "SBM_BANK|State Bank of Mauritius", active: false }],
    //     initialPaymentMonthlyModeOptions: [
    //         { value: "ONE_MONTH|One Month", active: false },
    //         { value: "TWO_MONTHS|Two Months", active: false }],
    //     renewalPaymentAnnualFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    //     renewalPaymentSemiAnnualFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    //     renewalPaymentQuarterlyFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    //     renewalPaymentMonthlyFrequencyOptions: [{ value: "CASH|Cash", active: false }, { value: "CHEQUE|Cheque", active: false }, { value: "ECS_ACH|ECS/ACH", active: false }, { value: "E_MANDATE|Send E-mandate Link to Customer", active: false }],
    // })
    const renewalFrequencyOptions = [
        "CASH|Cash",
        "CHEQUE|Cheque",
        "ECS_ACH|ECS/ACH",
        "E_MANDATE|Send E-mandate Link to Customer",
        "E_MANDATE_ONLY|Send E-mandate Only Link To Customer"
    ];
    const [options, setOptions] = useState({
        initialPaymentOptions: ["CASH|Cash", "CHEQUE|Cheque", "DEMAND_DRAFT|Demand draft", "NEFT|NEFT", "ONLINE_LINK|Online link", "ONLINE_BILL_DESK|Online Payment", "PAYMENT_AT_BANK_CHEQUE|Pay at bank cheque", "PAYMENT_AT_BANK_CASH|Pay at bank cash", "FUND_TRANSFER|Fund Transfer", "DIRECT_DEBIT|Direct Debit", "FINCARE_BANK|Fincare Bank"],
        initialPaymentAtBankOptions: ["HDFC_BANK|Hdfc Bank", "ALLAHABAD_BANK|Allahabad Bank", "YES_BANK|Yes Bank", "AXIS_BANK|Axis Bank", "KBL_BANK|Karnataka Bank", "SBM_BANK|State Bank of Mauritius"],
        initialPaymentMonthlyModeOptions: ["ONE_MONTH|One Month", "TWO_MONTHS|Two Months"],
        renewalPaymentAnnualFrequencyOptions: renewalFrequencyOptions,
        renewalPaymentSemiAnnualFrequencyOptions: renewalFrequencyOptions,
        renewalPaymentQuarterlyFrequencyOptions: renewalFrequencyOptions,
        renewalPaymentMonthlyFrequencyOptions: renewalFrequencyOptions
    })
    const dispatch = useDispatch();
    const inputHandler = (e, item) => {
        const data = {
            ...proposalNumber,
            [item]: e.target.value
        }
        setProposal(data)
    }

    const set_payemtOptions = (data) => {

        setApiPayment(data)
    }
    const getAllItem = () => {
        const { partnerName, subChannel, channel, sources } = proposalNumber;
        const param = `partnerName=${partnerName}&subChannel=${subChannel}&channel=${channel}&sources=${sources}`
        const queryParam = param ? param : "partnerName&subChannel&channel&sources"
        axios.get(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/instaRuleSheet?${queryParam}
        `, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem('token'),
            }
        }).then((res) => {
            dispatch({ type: 'LOADER_FALSE' })
            if (res && res.data) {
                setData(res.data)
                toaster('success', res.data.message)
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (err && err.data) {
                toaster('error', err.data.message)
            }
        })
    }

    const handleConfig = (name, key, value) => {
        value = key === "yes"
        let id;
        if (typeof name === 'string' && (name.includes('term') || name.includes('savings') || name.includes('customerConsentRequired') || name.includes('agentConsentRequired') || name.includes('neftpayment') || name.includes('cashPayment') || name.includes('issuanceType') || name.includes('accountAggregator') || name.includes('upfrontPayment') || name.includes('parallelConsent') || name.includes('idpProcess'))) {
            const data = name.split(" ");
            id = data && data[0]
            name = data && data[1]
        }
        const dataItem = data.body.filter((item) => {
            return item.id == id;
        })
        if (name === "issuanceType") {
            value = key === "yes" ? "EASE" : "NEWGEN"
        }
        let updatedItem = {
            ...dataItem[0],
            [name]: value
        }

        updateInsta(updatedItem)
    }
    const updateInsta = (updatedItem) => {
        axios.put(`${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/update-insta-rule
    `, updatedItem, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": localStorage.getItem('token'),
            }
        })
            .then((res) => {
                dispatch({ type: 'LOADER_FALSE' })
                if (res && res.data) {
                    if (res?.data?.body) {
                        getAllItem();
                    }
                    toaster('success', res.data.message)
                }
            })
            .catch((err) => {
                dispatch({ type: 'LOADER_FALSE' });
                if (err && err.data) {
                    toaster('error', err.data.message)
                }
            })
    }
    const getEasePointingProductsUrl = (ruleId) =>
        `${apiConstants().PROPOSEL_API_URL}api/v1/proposal/instaVerify/instaRule/${ruleId}/easePointingProducts`;

    const getRowProductCodes = (item) => (
        Array.isArray(item?.easePointingProducts) ? item.easePointingProducts : []
    );

    const openEasePointingModal = (item) => {
        setEasePointingRow(item);
        setSelectedProductCodes(getRowProductCodes(item));
        setEasePointingProductSearch('');
        setShowEasePointingModal(true);
    };

    const closeEasePointingModal = () => {
        setShowEasePointingModal(false);
        setEasePointingProductSearch('');
    };

    const easePointingProductChange = (productCode) => {
        setSelectedProductCodes((prev) => (
            prev.includes(productCode)
                ? prev.filter((code) => code !== productCode)
                : [...prev, productCode]
        ));
    };

    const submitEasePointingProducts = () => {
        if (!easePointingRow?.id) {
            return;
        }

        const payload = {
            productCodes: selectedProductCodes,
        };

        dispatch({ type: 'LOADER_TRUE' });
        axios.put(
            getEasePointingProductsUrl(easePointingRow.id),
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": localStorage.getItem('token'),
                }
            }
        ).then((res) => {
            dispatch({ type: 'LOADER_FALSE' });
            if (res?.data) {
                closeEasePointingModal();
                getAllItem();
                toaster('success', res.data.message || 'Ease pointing products saved successfully');
            }
        }).catch((err) => {
            dispatch({ type: 'LOADER_FALSE' });
            toaster('error', err?.data?.message || 'Failed to save ease pointing products');
        });
    };

    const setComponent = (item, key) => {
        if (key === 'easePointingProducts') {
            return (
                <button
                    type="button"
                    className="custom-button"
                    onClick={() => openEasePointingModal(item)}
                >
                    Edit
                </button>
            );
        }

        let type = item[key] === true || item[key] === 'EASE' ? "yes" : "no";
        return (item.channel === 'AGENCY' && key !== "issuanceType" && key !== "customerConsentRequired" && key !== "agentConsentRequired" && key !== "neftpayment" && key !== "cashPayment" && key !== 'accountAggregator' && key !== 'upfrontPayment'&& key !== 'parallelConsent' && key !== 'idpProcess' ? 'NA*' :
            <YesNoRadioButton
                cssClass="insta-view-grid__toggle"
                handleChange={(name, key, value) => {
                    handleConfig(name, key, value)
                }}
                rules={{
                    editable: true,
                }}
                yesValue={"yes"}
                noValue={"no"}
                checked={type}
                issuanceType={key === "issuanceType"}
                dataname={key === 'savings' ? item.id + ' savings' : key === "term" ? item.id + " term" : key === "neftpayment" ? item.id + " neftpayment" : key === "cashPayment" ? item.id + " cashPayment" : key === "customerConsentRequired" ? item.id + " customerConsentRequired" : key === "issuanceType" ? item.id + " issuanceType" : key === 'accountAggregator' ? item.id + ' accountAggregator' : key === 'upfrontPayment' ? item.id + ' upfrontPayment'  : key === 'parallelConsent' ? item.id + ' parallelConsent' : key === 'idpProcess' ? item.id + ' idpProcess' : item.id + " agentConsentRequired"}
            />)
    }

    useEffect(() => {
        getAllItem();
        dispatch(getProductList());
    }, [])

    const search = (e) => {
        e.preventDefault()
        getAllItem()
    }
    const paymentMethodChange = (item, type) => {
        const apiData = JSON.parse(JSON.stringify(apiPaymantOption))
        if (apiData[type] && apiData[type]?.includes(item)) {
            apiData[type] = apiData[type].filter((val) => val !== item);
        } else {
            apiData[type] && apiData[type].push(item);
        }
        setApiPayment({
            ...apiData
        })

    }
    const submitOptions = () => {
        updateInsta(apiPaymantOption)
    }
    return (
        <div className="proposal-dashboard insta-view-grid">
            <div className="proposal-dashboard__header insta-view-grid__header">
                <h2 className="proposal-dashboard__title">Insta View Grid</h2>
                <p className="proposal-dashboard__subtitle">
                    Search and manage insta verify rule sheet configuration
                </p>
            </div>
            <div className="insta-view-grid__panel">
                <form className="insta-view-grid__form" onSubmit={search}>
                    <div className="insta-view-grid__compact-grid">
                        <div className="insta-view-grid__field">
                            <label className="insta-view-grid__label" htmlFor="insta-partner-name">
                                Partner Name
                            </label>
                            <input
                                id="insta-partner-name"
                                onChange={(e) => inputHandler(e, 'partnerName')}
                                value={proposalNumber.partnerName}
                                className="insta-view-grid__input"
                                type="text"
                                placeholder="Partner Name"
                                name="proposal"
                            />
                        </div>
                        <div className="insta-view-grid__field">
                            <label className="insta-view-grid__label" htmlFor="insta-sub-channel">
                                Sub Channel
                            </label>
                            <input
                                id="insta-sub-channel"
                                onChange={(e) => inputHandler(e, 'subChannel')}
                                value={proposalNumber.subChannel}
                                className="insta-view-grid__input"
                                type="text"
                                placeholder="Sub Channel"
                                name="subChanel"
                            />
                        </div>
                        <div className="insta-view-grid__field">
                            <label className="insta-view-grid__label" htmlFor="insta-channel">
                                Channel
                            </label>
                            <input
                                id="insta-channel"
                                onChange={(e) => inputHandler(e, 'channel')}
                                value={proposalNumber.channel}
                                className="insta-view-grid__input"
                                type="text"
                                placeholder="Channel"
                                name="channel"
                            />
                        </div>
                        <div className="insta-view-grid__field">
                            <label className="insta-view-grid__label" htmlFor="insta-sources">
                                Sources
                            </label>
                            <input
                                id="insta-sources"
                                onChange={(e) => inputHandler(e, 'sources')}
                                value={proposalNumber.sources}
                                className="insta-view-grid__input"
                                type="text"
                                placeholder="Sources"
                                name="sources"
                            />
                        </div>
                    </div>
                    <div className="insta-view-grid__actions">
                        <button type="submit" className="insta-view-grid__btn insta-view-grid__btn--primary">
                            Search
                        </button>
                    </div>
                </form>
            </div>

            {data && data.body && (
                <div className="proposal-dashboard__table-section insta-view-grid__table-section">
                    <DataTable
                    cellHeaders={['channel', 'channelGroup', 'partnerName', 'Ease Pointing Products', 'neftpayment', 'Payments',
                        // 'cashPayment', 
                        'savings', 'sources', 'subChannel', 'term', 'Ease/NewGen', 'Account Aggregator', 'Upfront Payment', 'Parallel Consent',
                        ...(isDev ? ['IDP'] : [])]
                    }
                    data={data.body}
                    keys={['channel', 'channelGroup', 'partnerName', 'easePointingProducts', 'neftpayment', "customButtons",
                        //  'cashPayment', 
                        'savings', 'sources', 'subChannel', 'term', 'issuanceType', 'accountAggregator', 'upfrontPayment', 'parallelConsent',
                        ...(isDev ? ['idpProcess'] : [])]
                    }
                    addSerialNo={true}
                    PerPageApiData={false}
                    converTdToComponent={'term'}
                    secondconverTdToComponent={'savings'}
                    thirdconverTdToComponent={'customerConsentRequired'}
                    fourthconverTdToComponent={"neftpayment"}
                    // fifthconvertTdToComponent={"cashPayment"}
                    sixthconvertTdToComponent={"agentConsentRequired"}
                    seventhconvertTdToComponent={'issuanceType'}
                    AAconvertTdToComponent={'accountAggregator'}
                    upfrontconvertTdToComponent={'upfrontPayment'}
                    parallelconvertTdToComponent={'parallelConsent'}
                    idpconvertTdToComponent={isDev ? 'idpProcess' : undefined}
                    easePointingconvertTdToComponent={'easePointingProducts'}
                    componentToBeConverted={setComponent}
                    paginationItems={data.body}
                    alwaysShown={false}
                    onCustomButtonClick={(item) => {
                        setshowEditModal(true);
                        set_payemtOptions(item)
                    }}
                />
                </div>
            )}
            <div className="insta-view-grid__note">
                <div className="insta-view-grid__note-title">Note</div>
                <div className="insta-view-grid__note-points">
                    <p>1. The Proposal with the Channel name as &apos;AGENCY&apos; &amp; Sub Channel name as &apos;PP&apos;, Insta2.0 will be triggered.</p>
                    <p>2. The Proposal with the Channel name as &apos;AGENCY&apos; &amp; Coverage Annualized Premium value less than Rs. 30,000, Insta2.0 will be triggered.</p>
                </div>
            </div>
            {showEditModal && (
                <MobilePopUp onClose={() => {
                    setshowEditModal(false);
                }}>
                    <div className='paymentOptions'>
                        <h2>PAYMENT OPTIONS:</h2>
                        {
                            Object.keys(options).map((methods, i) => {

                                return (
                                    <>
                                        {options[methods].length > 0 && <h3>{methods}</h3>}
                                        <div className="pay_options">
                                            {options[methods]?.map((item, key) => {
                                                return (
                                                    <button className={`${apiPaymantOption[methods]?.includes(item) ? 'activebt' : ''} options_name`} key={key} onClick={(e) => paymentMethodChange(item, methods)}>{item.split('|') && item.split('|')[1]}</button>
                                                )

                                            })}
                                        </div>
                                    </>
                                )
                            })
                        }
                        <button onClick={submitOptions}>Submit</button>
                    </div>
                </MobilePopUp>
            )
            }
            {showEasePointingModal && (
                <MobilePopUp onClose={closeEasePointingModal}>
                    <div className="insta-view-grid__modal-form">
                        <h3 className="insta-view-grid__modal-title heading-left">Ease Pointing Products</h3>
                        <div className="insta-view-grid__modal-search">
                            <div className={`insta-view-grid__search-field ${easePointingProductSearch ? 'has-value' : ''}`}>
                                <span className="insta-view-grid__search-icon" aria-hidden="true">
                                    <i className="fa fa-search" />
                                </span>
                                <input
                                    id="ease-pointing-product-search"
                                    type="search"
                                    className="insta-view-grid__input--search"
                                    placeholder="Search by product name or code"
                                    value={easePointingProductSearch}
                                    onChange={(e) => setEasePointingProductSearch(e.target.value)}
                                    autoFocus
                                    aria-label="Search products"
                                />
                                {easePointingProductSearch && (
                                    <button
                                        type="button"
                                        className="insta-view-grid__search-clear"
                                        onClick={() => setEasePointingProductSearch('')}
                                        aria-label="Clear search"
                                    >
                                        &times;
                                    </button>
                                )}
                            </div>
                            <div className="insta-view-grid__search-meta">
                                <span className="insta-view-grid__search-badge">
                                    {easePointingProductSearch
                                        ? `${filteredEasePointingProducts.length} of ${productList.length} products`
                                        : `${productList.length} products`}
                                </span>
                                {selectedProductCodes.length > 0 && (
                                    <span className="insta-view-grid__search-badge insta-view-grid__search-badge--selected">
                                        {selectedProductCodes.length} selected
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="insta-view-grid__modal-section">
                            {filteredEasePointingProducts.length > 0 ? (
                                <div className="insta-view-grid__product-options">
                                    {filteredEasePointingProducts.map((product) => (
                                        <button
                                            type="button"
                                            className={`insta-view-grid__product-chip ${selectedProductCodes.includes(product.productCode) ? 'insta-view-grid__product-chip--active' : ''}`}
                                            key={product.productId}
                                            onClick={() => easePointingProductChange(product.productCode)}
                                        >
                                            {product.productName}
                                        </button>
                                    ))}
                                </div>
                            ) : (
                                <p className="insta-view-grid__no-results">
                                    No products match &quot;{easePointingProductSearch}&quot;.
                                </p>
                            )}
                        </div>
                        <div className="insta-view-grid__modal-actions">
                            <button
                                type="button"
                                className="insta-view-grid__btn insta-view-grid__btn--primary"
                                onClick={submitEasePointingProducts}
                            >
                                Submit
                            </button>
                        </div>
                    </div>
                </MobilePopUp>
            )}
        </div >
    )
}

export default InstaVerifyList;
